import { useQuery } from '@tanstack/react-query';
import { portalApi } from '@/lib/api/portal.js';
import { formatCurrency, formatDateTime } from '@/lib/format.js';

export function PortalInvoicesPage() {
  const invoicesQuery = useQuery({
    queryKey: ['portal', 'invoices'],
    queryFn: portalApi.invoices,
  });

  const invoices = (invoicesQuery.data ?? []) as Array<{
    ticketNumber: string;
    closedAt: string | null;
    deviceSummary: string;
    repairSummary: string;
    total: string;
    paid: string;
    receipt: string | null;
  }>;

  return (
    <div className="space-y-5">
      <h1 className="text-2xl font-bold">Invoices</h1>
      <div className="space-y-3">
        {invoices.map((inv) => (
          <div
            key={inv.ticketNumber}
            className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm"
          >
            <div className="flex justify-between">
              <div className="font-bold">{inv.ticketNumber}</div>
              <div className="text-sm text-slate-500">
                {inv.closedAt ? formatDateTime(inv.closedAt) : ''}
              </div>
            </div>
            <p className="mt-1 text-sm text-slate-600">{inv.deviceSummary}</p>
            <p className="text-sm text-slate-500">{inv.repairSummary}</p>
            <div className="mt-2 flex justify-between text-sm font-semibold">
              <span>Total {formatCurrency(inv.total)}</span>
              <span>Paid {formatCurrency(inv.paid)}</span>
            </div>
          </div>
        ))}
        {invoices.length === 0 && !invoicesQuery.isLoading ? (
          <p className="rounded-2xl border border-dashed border-slate-200 bg-white p-8 text-center text-slate-500">
            No invoices yet.
          </p>
        ) : null}
      </div>
    </div>
  );
}
